/**
 * Note ids the client invents before the server has issued one.
 *
 * Two flows hand a note an id of their own: the highlight drawer seeds a
 * placeholder slide so a "new note" opens as an ordinary editable note, and the
 * store inserts an optimistic `temp-note-<ms>` row while POST /notes is in
 * flight. Both are real ids to the UI and meaningless to the API — a PATCH
 * addressed to either can only 404. On 2026-09-05 the autosave did exactly
 * that 187 times in prod (Datadog issue dab53428), one keystroke at a time.
 *
 * Everything that decides whether to call the API asks `isPersistedNoteId`;
 * nothing else should compare against these literals.
 */
export const PENDING_NOTE_ID = '__pending-new-note__';
export const TEMP_NOTE_PREFIX = 'temp-note-';

/** Trailing debounce for the drawer's live note autosave. */
export const NOTE_AUTOSAVE_DEBOUNCE_MS = 400;

export const newTempNoteId = () => `${TEMP_NOTE_PREFIX}${Date.now()}`;

/** True only for an id the server issued (or could have): non-empty, not a placeholder. */
export function isPersistedNoteId(id) {
  return (
    typeof id === 'string' &&
    id.length > 0 &&
    id !== PENDING_NOTE_ID &&
    !id.startsWith(TEMP_NOTE_PREFIX)
  );
}
